import { type AbstractImage, NativeImage } from '@mntn-dev/ui-utilities'
import type { Person } from '../../../../types/person.ts'
import { Avatar, type AvatarProps } from '../../../avatar/avatar.tsx'
import type { AvatarEntity } from '../../../avatar/types.ts'

export type CardDetailsCompactAvatarProps = AvatarProps & {
  entity?: AvatarEntity
  image?: AbstractImage
  person?: Person
}

export const CardDetailsCompactAvatar = ({
  entity,
  image = NativeImage,
  size,
  ...avatarProps
}: CardDetailsCompactAvatarProps) => (
  <div className="self-center">
    <Avatar size={size ?? 'xs'} {...avatarProps}>
      {entity && <Avatar.Entity entity={entity} image={image} />}
    </Avatar>
  </div>
)
